(function () {
    document.addEventListener('DOMContentLoaded', function () {
      var productSliders = document.querySelectorAll('.product-slider');

      productSliders.forEach(function (slider) {
        var swiper = new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: slider.querySelector('.swiper-pagination'),
            clickable: true,
          },
        });

        swiper.on('transitionEnd', function () {
          // Obtener el índice del slide activo
          var activeIndex = swiper.activeIndex;

          // Obtener la lista de bullets
          var paginationBullets = slider.querySelectorAll('.swiper-pagination-bullet');

          // Eliminar la clase swiper-pagination-bullet-active de todos los bullets
          paginationBullets.forEach(function (bullet) {
            bullet.classList.remove('swiper-pagination-bullet-active');
          });

          // Agregar la clase swiper-pagination-bullet-active al bullet correspondiente
          paginationBullets[activeIndex].classList.add('swiper-pagination-bullet-active');

          swiper.pagination.update();
        });
      });
    });
})();
